/**
 *
 * @prettier
 */
var AbstractViewModel = require("./AbstractViewModel")
var AbstractWS = require("../ws/AbstractWS")

 function QueueSelectionViewModel(parent, store, queueWS) {
  var self = this;

  self.selectedQueueIds = ko.observableArray([]);
  self.isDisplayQueueList = ko.observable(true);
  self.parent = parent;
  self.store = store;
  self.queuesWebService = queueWS;

  self.handleToggleAllQueueIds = self.handleToggleAllQueueIds.bind(this);
  self.handleToggleQueueList = self.handleToggleQueueList.bind(this);
  self.handleToggleAllQueueStates = self.handleToggleAllQueueStates.bind(this);

  AbstractViewModel.apply(this, arguments);

  self.availableQueues = ko.computed(self._availableQueues.bind(this), self, { deferEvaluation: true });
  self.allQueueIds = ko.computed(self._allQueueIds.bind(this), self, { deferEvaluation: true });
  self.displayLocationName = ko.computed(self._displayLocationName.bind(this), self, { deferEvaluation: true });
  self.queuesAreAvailable = ko.computed(self._queuesAreAvailable.bind(this), self, { deferEvaluation: true });
  self.noQueuesAvailable = ko.computed(self._noQueuesAvailable.bind(this), self, { deferEvaluation: true });
  self.queueSelectionVisible = ko.computed(self._queueSelectionVisible.bind(this), self, { deferEvaluation: true });
  self.showQueueSelectPrompt = ko.computed(self._showQueueSelectPrompt.bind(this), self, { deferEvaluation: true });

  return self;
}

QueueSelectionViewModel.prototype = Object.create(AbstractViewModel.prototype);
QueueSelectionViewModel.prototype.constructor = QueueSelectionViewModel;

/**
 * returns a list of queues available to the authenticated user
 *
 * @method _availableQueues
 * @returns {Array<Object>}
 */
 QueueSelectionViewModel.prototype._availableQueues = function() {
  return this.parent.queues();
}

/**
 * returns a list of queues available to the authenticated user
 *
 * @method allQueueIds
 * @returns {Array<Number>}
 */
QueueSelectionViewModel.prototype._allQueueIds = function() {
  return this.availableQueues().map(function(queue) {
    return queue.id;
  });
}

/**
 * Lets us know if the location name should be displayed
 *
 * @method _displayLocationName
 * @returns {Boolean}
 */
QueueSelectionViewModel.prototype._displayLocationName = function() {
  return this.parent.selectedLocationIds().length > 1;
}

/**
 * Reports if there are queues available for selection
 *
 * @method _queuesAreAvailable
 * @returns {Boolean}
 */
QueueSelectionViewModel.prototype._queuesAreAvailable = function() {
  return this.availableQueues().length > 0;
}

/**
 * Determines if the queue list is presented
 *
 * @method _queueSelectionVisible
 * @returns {Boolean}
 */
QueueSelectionViewModel.prototype._queueSelectionVisible = function() {
  if (this.parent.selectedLocationIds().length > 0 && !this.parent.showListView()) {
    if (this.isDisplayQueueList() || this.selectedQueueIds().length === 0) {
      return true;
    }
  }

  return false;
}

/**
 * Lets us know if the queues are currently being loaded
 *
 * @method _noQueuesAvailable
 * @returns {Boolean}
 */
QueueSelectionViewModel.prototype._noQueuesAvailable = function() {
  return this.availableQueues().length === 0;
}

/**
 * Determines when the 'Select queues to manage' message should be shown
 *
 * @method _showQueueSelectPrompt
 * @returns {Boolean}
 */
QueueSelectionViewModel.prototype._showQueueSelectPrompt = function() {
  return (
    this.selectedQueueIds().length === 0 &&
    this.parent.selectedLocationIds().length > 0 &&
    !this.parent.showListView() &&
    !this.parent.showServiceResults()
  );
}

/**
 * Adds a queueId to the selectedQueueIds list if it is not already selected
 *
 * @method addQueueId
 * @returns None
 */
QueueSelectionViewModel.prototype.addQueueId = function(queueId) {
  if (this.selectedQueueIds().indexOf(queueId) === -1) {
    this.selectedQueueIds.push(queueId);
  }
}

/**
 * Removes all queues from the selectedQueueList
 *
 * @method clearAllSelectedQueues
 * @returns none
 */
QueueSelectionViewModel.prototype.clearAllSelectedQueues = function() {
  this.selectedQueueIds.removeAll();
}

/**
 * Interface to unset the display state of the queue selection
 *
 * @method hideQueueList
 * @returns none
 */
QueueSelectionViewModel.prototype.hideQueueList = function() {
  this.isDisplayQueueList(false);
}

/**
 * A convenience method to prevent the user from having to unneccesarilly
 * engage with the UI
 *
 * @method selectOnlyQueue
 * @returns none
 */
QueueSelectionViewModel.prototype.selectOnlyQueue = function() {
  if (this.availableQueues().length === 1) {
    this.selectedQueueIds([this.allQueueIds()[0]]);
    this.isDisplayQueueList(false);
  }
}

/**
 * Retrieve all of the previously selected Queue IDs from browser storage
 * (localStorage/Cookie).
 *
 * If any of the previously selected queues no longer exist, an empty list is
 * returned; the server is our canonical source, and the localStorage won't be trusted.
 *
 * @return {Array<Number>} an array of previously selected Queue IDs
 */
QueueSelectionViewModel.prototype.retrieveQueuesForLocations = function() {
  var queuesForLocations = JSON.parse(
    this.store.get(this.parent.storageKeys.queuesForLocations)
  );

  if (!queuesForLocations) {
    queuesForLocations = {};
  }

  return queuesForLocations;
}

/**
 * Restore the Queues for Locations
 *
 */
QueueSelectionViewModel.prototype.restoreQueuesForLocations = function() {
  var employeeId = this.parent.employeeId();
  var queuesForLocations = this.retrieveQueuesForLocations();
  var selectedLocations = this.parent.selectedLocationIds()
  if (selectedLocations.length > 0) {
    var queues =
      employeeId && queuesForLocations && queuesForLocations[employeeId] ?
      Object.keys(queuesForLocations[employeeId])
      // The keys are returned as strings from Object.keys and need to be integers
      // so we can use indexOf.
      .map(function(v) {
        return parseInt(v, 10);
      })
      // Only use the selected locations
      .filter(function(locationId) {
        return selectedLocations.indexOf(locationId) !== -1;
      })
      // Pull all the Queues, from each Location, into one list.
      .reduce(function(restoredQueues, locationId) {
        var queuesForLocation =
          queuesForLocations[employeeId][locationId];

        // If no queues were previously saved...
        if (queuesForLocation.length == 0) {
          // ...select ALL queues for the location
          queuesForLocation = parent
            .queues()
            .filter(function(q) {
              return (q.locationId = locationId);
            })
            .map(function(q) {
              return q.id;
            });
        }

        return restoredQueues.concat(queuesForLocation);
      }, []) :
      [];

    // Remove non-existent Queues
    var allQueues = this.queuesWebService.allQueueIds();
    queues = queues.filter(function(queueId) {
      return allQueues.indexOf(queueId) !== -1;
    });

    if (queues && queues.length > 0) {
      this.selectedQueueIds(queues);
    } else {
      setTimeout(function () {
        this.handleToggleAllQueueIds(true);
      }.bind(this));
    }
  }
}

/**
 * Store a list of selected Queues by Location
 *
 * @param {Number} employeeId
 * @param {Array<Number>} selectedQueues
 * @returns none
 */
QueueSelectionViewModel.prototype.storeQueuesForLocations = function(employeeId, selectedQueues) {
  var queuesForLocations = selectedQueues.reduce(function(
    locationQueues,
    queue
  ) {
    if (typeof queue === "number") {
      queue = this.queuesWebService.getQueueById(queue);
    }

    if (locationQueues[queue.locationId] === undefined) {
      locationQueues[queue.locationId] = [];
    }

    locationQueues[queue.locationId].push(queue.id);

    return locationQueues;
  }.bind(this), {});


  // Overwrite per Location. If we deselect a Location, we don't want to "forget"
  // the queues selected for that employee or location, so rather than overwrite
  // the whole object, we update the employee's location entries (properties).
  var storedQueuesForLocations = this.retrieveQueuesForLocations();
  var currentEmployeeQueuesForLocation = storedQueuesForLocations[employeeId] ?
    storedQueuesForLocations[employeeId] :
    {};
  storedQueuesForLocations[employeeId] = Object.assign(
    currentEmployeeQueuesForLocation,
    queuesForLocations
  );

  // Remember selected Queues
  this.store.set(
    this.parent.storageKeys.queuesForLocations,
    JSON.stringify(storedQueuesForLocations)
  );
}

/**
 * Simple flag flipper. The variable flipped (isDisplayQueueList)
 * is used to determine if a CSS class name is appended to the
 * body tag
 *
 * @method handleToggleQueueList
 * @returns {Boolean} true
 */
QueueSelectionViewModel.prototype.handleToggleQueueList = function() {
  if (this.selectedQueueIds().length > 0) {
    var show = !this.isDisplayQueueList();

    this.isDisplayQueueList(show);
  }
}

/**
 * Inverse queue selection of all available queues
 *
 * @method handleToggleAllQueueIds
 * @returns none
 */
QueueSelectionViewModel.prototype.handleToggleAllQueueIds = function(select) {
  var queueList = null;
  var queueIds = this.allQueueIds();

  if (select === true) {
    queueList = select ? queueIds : [];
  } else {
    queueList =
      this.selectedQueueIds().length === queueIds.length ? [] : queueIds;
  }

  this.selectedQueueIds(queueList);
}

/**
 * Updates the queue data in the sidebar queue list
 *
 * @method updateQueueList
 * @param {Number} queueuId
 * @param {Boolean} force
 * @returns none
 */
QueueSelectionViewModel.prototype.updateQueueList = function(queueId, force) {
  if (force || this.queueSelectionVisible()) {
    this.availableQueues().forEach(function(queue) {
      if (!queueId || Number(queueId) === queue.id) {
        queue.updateSidebar();
      }
    });
  }
}

/**
 * Set all the queue states to started or stopped
 *
 * @method handleToggleAllQueueStates
 * @param [String] sNewState If passed wlil force the action
 * @returns none
 */
QueueSelectionViewModel.prototype.handleToggleAllQueueStates = function(newState) {
  var action = this.parent.allQueuesActive() ? "stop" : "start";

  // If a valid parameter was passed used that as the new state
  if (
    typeof newState === "string" && ["stop", "start"].indexOf(newState.toLowerCase()) > -1
  ) {
    action = newState.toLowerCase();
  }

  var confirmedStop =
    action === "stop" &&
    window.confirm("Are you sure you want to deactivate all queues?");

  if (confirmedStop || action === "start") {
    var ws = new AbstractWS(self);
    ws.method("POST");
    ws.name = "QueueActivator";
    ws.dataType = "text";
    var joinedQueueIds = this.allQueueIds().join(",")
    ws.serviceURL = ko.computed(function() {
      return (
        "/qless/api/v1/employee/queues/" +
        joinedQueueIds +
        "/" +
        action
      );
    });
    ws.doRequest();
  }
}

module.exports = QueueSelectionViewModel;
